// Mock data for demo requests
export const mockDemoRequests = [];

export const saveDemoRequest = (data) => {
  const request = {
    id: Date.now(),
    ...data,
    timestamp: new Date().toISOString()
  };
  mockDemoRequests.push(request);
  return request;
};

export const faqData = [
  {
    question: "Apa itu Sistem IPL?",
    answer: "Sistem IPL adalah platform digital untuk mengelola Iuran Pemeliharaan Lingkungan di kompleks perumahan atau apartemen Anda. Sistem ini memudahkan pengurus dalam mencatat, memantau, dan mengelola pembayaran iuran warga secara otomatis."
  },
  {
    question: "Bagaimana cara kerja sistem notifikasi pembayaran?",
    answer: "Sistem akan mengirimkan notifikasi otomatis via WhatsApp atau email kepada warga yang belum melakukan pembayaran. Notifikasi dapat dikustomisasi sesuai kebutuhan kompleks Anda."
  },
  {
    question: "Apakah data kami aman?",
    answer: "Ya, keamanan data adalah prioritas utama kami. Semua data dienkripsi dan disimpan di server yang aman dengan backup rutin. Kami juga mematuhi standar keamanan data internasional."
  },
  {
    question: "Berapa lama waktu implementasi?",
    answer: "Implementasi sistem biasanya memakan waktu 1-2 minggu, tergantung kompleksitas kebutuhan. Tim kami akan membantu proses setup dan pelatihan penggunaan sistem."
  },
  {
    question: "Apakah bisa digunakan untuk multiple kompleks?",
    answer: "Ya, untuk paket Premium kami mendukung pengelolaan multiple kompleks dalam satu dashboard. Sangat cocok untuk developer atau pengelola yang menangani beberapa kompleks."
  },
  {
    question: "Bagaimana cara upgrade dari Basic ke Premium?",
    answer: "Anda dapat upgrade kapan saja melalui dashboard atau hubungi tim support kami. Tidak ada biaya tambahan dan data Anda akan tetap aman selama proses upgrade."
  }
];
